module.exports = __webpack_public_path__ + "img/responsive crc-02.f7887342.jpg";